export default __webpack_public_path__ + "static/media/user-09.246ba6a2.jpg";